import { StyleObj } from '../../@types';
import { Theme } from '@mui/material/styles';
import { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN } from '../../types/enums';

type Styles = {
  cursorPointer: boolean;
};

export const BASE_HEADING_STYLES = {
  cursor: 'pointer' as const,
  padding: {
    xs: '6px 8px',
    md: '8px 16px',
    lg: '16px 24px',
  },
  borderTop: '1px solid',
  borderColor: 'info.600',
  width: '100%',
};

export const makeBaseStyles = ({ cursorPointer }: Styles): StyleObj => ({
  heading: (theme: Theme) => ({
    ...BASE_HEADING_STYLES,
    cursor: cursorPointer ? 'pointer' : 'default',
    background: `linear-gradient(90deg, ${theme.palette.primary.main} 10.78%, rgba(20, 128, 92, 0.00) 90.63%)`,
  }),
  headingWrapper: {
    mt: 0,
  },
});

export const makeGolaStyles = ({ cursorPointer }: Styles): StyleObj => {
  const base = makeBaseStyles({ cursorPointer });

  return {
    ...base,
    heading: (theme: Theme) => ({
      ...BASE_HEADING_STYLES,
      padding: '8px 12px',
      cursor: cursorPointer ? 'pointer' : 'default',
      background: theme.palette.primary.main,
    }),
  };
};

const BET365_STYLES = {
  title: {
    whiteSpace: 'nowrap',
    typography: {
      xs: 'h5',
      md: 'h4',
      lg: 'h3',
    },
    fontWeight: 700,
    letterSpacing: {
      xs: 1,
      md: 0.1,
    },
    color: (theme: Theme) => theme.palette.primary.contrastText,
  },
  subtitle: {
    typography: {
      xs: 'body3',
      md: 'subtitle2',
    },
    fontWeight: 500,
  },
  linkIcon: {
    fontSize: {
      xs: 18,
      md: 20,
      lg: 24,
    },
  },
  linkWrapper: {
    justifyContent: 'flex-start',
    width: 'auto',
  },
};

const GOLA_STYLES = {
  title: {
    whiteSpace: 'nowrap',
    typography: {
      xs: 'body2',
      md: 'body2',
      lg: 'body2',
    },
    fontWeight: 400,
    letterSpacing: {
      xs: 0,
      md: 0,
    },
    color: (theme: Theme) => theme.palette.primary.contrastText,
  },
  subtitle: {
    typography: {
      xs: 'body3',
      md: 'body3',
    },
    fontWeight: 400,
  },
  linkWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  linkIcon: {
    color: 'info.100',
    fontSize: {
      xs: 15,
      md: 15,
      lg: 15,
    },
  },
};

export const COMPONENT_SKIN_STYLES = {
  [SKIN.BET365]: BET365_STYLES,
  [SKIN.GOLA]: GOLA_STYLES,
};

export const getHeadingSkinStyles = (cursorPointer: boolean): SkinStylesMap<StyleObj> => ({
  [SKIN.BET365]: () => makeBaseStyles({ cursorPointer }),
  [SKIN.GOLA]: () => makeGolaStyles({ cursorPointer }),
});
